import React, { useState, useEffect } from 'react';
import {
    Box,
    Button, Card, CardBody, CardFooter, CardHeader, Divider, Heading, HStack, Image,
    Menu,
    MenuButton,
    MenuItem,
    MenuList,
    Modal, ModalBody, ModalCloseButton,
    ModalContent, ModalFooter, ModalHeader,
    ModalOverlay, SimpleGrid, Stack, Text,
    useDisclosure
} from "@chakra-ui/react";
import {ChevronDownIcon} from "@chakra-ui/icons";
import service_info from "../Sections/ServiceInfo";
import { useNavigate } from "react-router";

interface Control{
    isOpen: any;
    onOpen: any;
    onClose: any;
    title: string;
}


function ServiceCard({title, isOpen, onOpen, onClose}:Control){

    let navigate = useNavigate();
    const title_style_1 = { base: "14px", sm:"45px", md: "18px", lg: "4vh", "2xl":"21px"};
    const info = title?service_info[title]:null;
    const content = title?info["content"]:null ;
    const parent_path = title?info["path"]:null ;


    return(
        <>
            <Modal  isCentered isOpen={isOpen} onClose={onClose} >

                <ModalContent   minW = "90%" maxW = "90%" minH = "95%" maxH = "95%" borderRadius = "0" border = "1px solid whitesmoke">
                    <ModalHeader style = {{"box-shadow": "inset 0px 30px 55px whitesmoke"}} align = "center" borderTopRadius = "0px" bg = "white" color = "black">{title}</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody display={"flex"} justifyContent={"center"} alignItems={"start"}
                               style = {{"box-shadow": "inset 0px 0px 30px whitesmoke"}} fontSize = {title_style_1} overflowY={"auto"} marginRight={"5px"} marginLeft = "0px">
                        {
                            title?
                                //process each main category in ServiceInfo.js
                                <SimpleGrid columns={{base:1,md:2,lg:4,"2xl":4}} spacing = {2} mt = "20px" mb={ "20px"}  h = "fit-content" maxW={"70vw"}>
                                    {content.map((item,index)=>(

                                        <>
                                            <Card  w = "100%" h ="70vh" border={ "1px solid whitesmoke"}>

                                                <CardBody h={"20vh"}>
                                                    <Image
                                                        src={"/ServiceInfoImg/"+item.img_urls[0]}
                                                        borderRadius='lg'
                                                        w = "105%"
                                                        h = "20vh"
                                                    />
                                                    <Stack mt='6' spacing='3'>
                                                        <Box  h={"41vh"} overflowY = "auto">
                                                            <Heading fontSize={"20px"} >{item.description}</Heading>
                                                            <Text fontSize = {"14px"}  >


                                                            </Text>
                                                        </Box>

                                                    </Stack>
                                                </CardBody>
                                                <CardFooter justifyContent = {"space-between"} alignItems={"center"}>
                                                    {/*<Text color='#AD3F45' fontSize='2xl'>$450</Text>*/}
                                                    <Text mr={"20px"} fontSize='xl' as ="u" cursor={"pointer"} _hover = {{color:"grey"}} onClick={()=>{window.location.href = `/${parent_path}/${item.path}`;}}>View more</Text>
                                                </CardFooter>
                                            </Card>


                                            {/*<SimpleGrid columns={4} spacing = {10} mt = "20px" mb={ "20px"} overflow = "auto" maxH = "30vh" maxW={"65vw"}>*/}
                                            {/*    {item.img_urls.map((url,index)=>*/}
                                            {/*        //process each child category in ServiceInfo.js*/}
                                            {/*            <Image  boxSize = "15vw" src = {"/ServiceInfoImg/"+url} />*/}
                                            {/*    )}*/}
                                            {/*</SimpleGrid>*/}
                                        </>
                                    ))}
                                </SimpleGrid>
                                :null
                        }


                    </ModalBody>
                    <Divider></Divider>

                    <ModalFooter style = {{"box-shadow": "inset 0px 0px 55px whitesmoke"}}>
                        <Button colorScheme='gray' mr={3} onClick={onClose}>
                            Close
                        </Button>

                    </ModalFooter>
                </ModalContent>
            </Modal>

        </>
    )

}


export default ServiceCard;